const mutations = {
    USER_REQUEST: (state) => {
        state.status = 'loading';
    },
    USER_SUCCESS: (state, user) => {
        state.status = 'success';
        // state.profile = user.data;
        Vue.set(state, 'profile', user.data);
    },
    USER_ERROR: (state, err) => {
        // console.log(err);
        let errors=err.errors?err.errors:{};

        state.status = 'error';
        state.userErrors.record(errors);
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
